// extracted by mini-css-extract-plugin
export default {"header":"Header_header__DO49o","btns":"Header_btns__N6Gkw"};